import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramReportQuestion on AssessmentQuestionInterface {
    ... on RangeAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on CompetencyAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on IndividualGoalAssessmentQuestionNode {
      id
      questionType
    }
    ... on OverallGoalAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on IndividualRecognitionCoreValueAssessmentQuestionNode {
      id
      questionType
    }
    ... on OverallRecognitionCoreValueAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on CompetencyCriteriaAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on ResponsibilityAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
    }
    ... on TalentIndicatorAssessmentQuestionNode {
      id
      title
      description
      startValue
      endValue
      labels
      questionType
      responses
      labelDescriptions
      comment
      talentIndicator {
        id
        name
        customName
        talentIndicatorType
      }
    }
    ... on MultiChoiceAssessmentQuestionNode {
      id
      title
      description
      options
      questionType
      responses
      comment
    }
    ... on TextAssessmentQuestionNode {
      id
      title
      description
      questionType
      responses
      comment
    }
    ... on NpsAssessmentQuestionNode {
      id
      title
      description
      questionType
      responses
      comment
    }
  }
`;
